import {AnimatedMaskParticle, AnimatedMaskParticleArt} from '@fantasmagames/core/src/particles/AnimatedMaskParticle';
import {Emitter} from '@fantasmagames/core/src/particles/Emitter';
import {View} from '@fantasmagames/slot/src/common/view/View';
import {Position} from '@fantasmagames/slot/src/modules/reels/ReelConstants';
import {Container} from 'pixi.js';

export enum PARTICLE_EMITTER_NAMES {
	Nice = 'nice',
	Excellent = 'excellent',
	Big = 'big',
	Super = 'super',
	Mega = 'mega',
	Epic = 'epic',
	Explosion = 'explosion',
}

export class ParticleView extends View {
	protected _currentParticleEmitter: Emitter;
	protected _niceWinParticleEmitter: Emitter;
	protected _excellentWinParticleEmitter: Emitter;
	protected _bigWinParticleEmitter: Emitter;
	protected _superWinParticleEmitter: Emitter;
	protected _megaWinParticleEmitter: Emitter;
	protected _epicWinParticleEmitter: Emitter;

	protected _winExplosionParticleEmitter: Emitter;

	protected _bottomContainer: Container;
	protected _middleContainer: Container;

	protected _particleData: any;

	public init(): void {
		super.init();

		this.setupParticleContainers();
		this.setupParticleContainersPositions();
	}

	public setupParticleContainers(): void {
		this._bottomContainer = new Container();
		this._middleContainer = new Container();

		this.container.addChild(this._bottomContainer);
		this.container.addChild(this._middleContainer);

		this._middleContainer.name = 'mid particle container';
		this._bottomContainer.name = 'bot particle container';
	}

	public setupParticleContainersPositions(): void {
		let bottomContainerPosition: Position = this.layout.getAbsolutePosition('PARTICLE_COIN_EMITTER_LOW_WIN');
		let middleContainerPosition: Position = this.layout.getAbsolutePosition('PARTICLE_COIN_EMITTER');

		const screenMiddlePosition: Position = {
			x: this.resolutionManager.halfResolution.width,
			y: this.resolutionManager.halfResolution.height,
		};

		bottomContainerPosition = bottomContainerPosition ? bottomContainerPosition : screenMiddlePosition;
		middleContainerPosition = middleContainerPosition ? middleContainerPosition : screenMiddlePosition;

		this._bottomContainer.position.set(bottomContainerPosition.x, bottomContainerPosition.y);
		this._middleContainer.position.set(middleContainerPosition.x, middleContainerPosition.y);
	}

	public stopCurrentParticleEmitter(): void {
		if (this._currentParticleEmitter) {
			this._currentParticleEmitter.emit = false;
		}
	}

	public startEmitter(type: string): void {
		this.stopCurrentParticleEmitter();
		switch (type) {
			case PARTICLE_EMITTER_NAMES.Nice:
				if (this._niceWinParticleEmitter) {
					this.startParticleEmitter(this._niceWinParticleEmitter);
				} else {
					this._niceWinParticleEmitter = this.setUpEmitter(PARTICLE_EMITTER_NAMES.Nice);
					this.updateManager.add(this._niceWinParticleEmitter);
				}
				this._currentParticleEmitter = this._niceWinParticleEmitter;
				break;
			case PARTICLE_EMITTER_NAMES.Excellent:
				if (this._excellentWinParticleEmitter) {
					this.startParticleEmitter(this._excellentWinParticleEmitter);
				} else {
					this._excellentWinParticleEmitter = this.setUpEmitter(PARTICLE_EMITTER_NAMES.Excellent);
					this.updateManager.add(this._excellentWinParticleEmitter);
				}
				this._currentParticleEmitter = this._excellentWinParticleEmitter;
				break;
			case PARTICLE_EMITTER_NAMES.Big:
				if (this._bigWinParticleEmitter) {
					this.startParticleEmitter(this._bigWinParticleEmitter);
				} else {
					this._bigWinParticleEmitter = this.setUpEmitter(PARTICLE_EMITTER_NAMES.Big);
					this.updateManager.add(this._bigWinParticleEmitter);
				}
				this._currentParticleEmitter = this._bigWinParticleEmitter;
				break;
			case PARTICLE_EMITTER_NAMES.Super:
				if (this._superWinParticleEmitter) {
					this.startParticleEmitter(this._superWinParticleEmitter);
				} else {
					this._superWinParticleEmitter = this.setUpEmitter(PARTICLE_EMITTER_NAMES.Super);
					this.updateManager.add(this._superWinParticleEmitter);
				}
				this._currentParticleEmitter = this._superWinParticleEmitter;
				break;
			case PARTICLE_EMITTER_NAMES.Mega:
				if (this._megaWinParticleEmitter) {
					this.startParticleEmitter(this._megaWinParticleEmitter);
				} else {
					this._megaWinParticleEmitter = this.setUpEmitter(PARTICLE_EMITTER_NAMES.Mega);
					this.updateManager.add(this._megaWinParticleEmitter);
				}
				this._currentParticleEmitter = this._megaWinParticleEmitter;
				break;
			case PARTICLE_EMITTER_NAMES.Epic:
				if (this._epicWinParticleEmitter) {
					this.startParticleEmitter(this._epicWinParticleEmitter);
				} else {
					this._epicWinParticleEmitter = this.setUpEmitter(PARTICLE_EMITTER_NAMES.Epic);
					this.updateManager.add(this._epicWinParticleEmitter);
				}
				this._currentParticleEmitter = this._epicWinParticleEmitter;
				break;
			case PARTICLE_EMITTER_NAMES.Explosion:
				if (this._winExplosionParticleEmitter) {
					this.startParticleEmitter(this._winExplosionParticleEmitter);
				} else {
					this._winExplosionParticleEmitter = this.setUpEmitter(PARTICLE_EMITTER_NAMES.Explosion);
					this.updateManager.add(this._winExplosionParticleEmitter);
				}
				this._currentParticleEmitter = this._winExplosionParticleEmitter;
				break;
			default:
				break;
		}
	}

	protected setUpEmitter(type: string): Emitter {
		let particleConfig: any;
		let xMod: any;
		let yMod: any;
		let emitterContainer: Container;

		switch (type) {
			case PARTICLE_EMITTER_NAMES.Nice:
				particleConfig = this.getParticlesConfig(PARTICLE_EMITTER_NAMES.Nice);
				xMod = 2;
				yMod = 1;
				emitterContainer = this._bottomContainer;
				break;
			case PARTICLE_EMITTER_NAMES.Excellent:
				particleConfig = this.getParticlesConfig(PARTICLE_EMITTER_NAMES.Excellent);
				xMod = 2;
				yMod = 1;
				emitterContainer = this._bottomContainer;
				break;
			case PARTICLE_EMITTER_NAMES.Big:
				particleConfig = this.getParticlesConfig(PARTICLE_EMITTER_NAMES.Big);
				xMod = 2;
				yMod = 2;
				emitterContainer = this._middleContainer;
				break;
			case PARTICLE_EMITTER_NAMES.Super:
				particleConfig = this.getParticlesConfig(PARTICLE_EMITTER_NAMES.Super);
				xMod = 2;
				yMod = 2;
				emitterContainer = this._middleContainer;
				break;
			case PARTICLE_EMITTER_NAMES.Mega:
				particleConfig = this.getParticlesConfig(PARTICLE_EMITTER_NAMES.Mega);
				xMod = 2;
				yMod = 2;
				emitterContainer = this._middleContainer;
				break;
			case PARTICLE_EMITTER_NAMES.Epic:
				particleConfig = this.getParticlesConfig(PARTICLE_EMITTER_NAMES.Epic);
				xMod = 2;
				yMod = 2;
				emitterContainer = this._middleContainer;
				break;
			case PARTICLE_EMITTER_NAMES.Explosion:
				particleConfig = this.getParticlesConfig(PARTICLE_EMITTER_NAMES.Explosion);
				xMod = 2;
				yMod = 2;
				emitterContainer = this._middleContainer;
				break;
			default:
				console.error('missing type');

				return;
		}

		const emitter: Emitter = new Emitter(emitterContainer, particleConfig, this._particleData);
		emitter.particleConstructor = AnimatedMaskParticle;
		// emitterContainer.position.set(this.resolutionManager.resolution.width / xMod, this.resolutionManager.resolution.height / yMod);

		return emitter;
	}

	protected getParticlesConfig(name: string): AnimatedMaskParticleArt[] {
		let resourcePath: string;
		switch (name) {
			case PARTICLE_EMITTER_NAMES.Nice:
				resourcePath = 'resources/particles/NICE_WIN_COINS.json';
				break;
			case PARTICLE_EMITTER_NAMES.Excellent:
				resourcePath = 'resources/particles/EXCELLENT_WIN_COINS.json';
				break;
			case PARTICLE_EMITTER_NAMES.Big:
				resourcePath = 'resources/particles/BIG_WIN_COINS.json';
				break;
			case PARTICLE_EMITTER_NAMES.Super:
				resourcePath = 'resources/particles/SUPER_WIN_COINS.json';
				break;
			case PARTICLE_EMITTER_NAMES.Mega:
				resourcePath = 'resources/particles/MEGA_WIN_COINS.json';
				break;
			case PARTICLE_EMITTER_NAMES.Epic:
				resourcePath = 'resources/particles/EPIC_WIN_COINS.json';
				break;
			case PARTICLE_EMITTER_NAMES.Explosion:
				resourcePath = 'resources/particles/EPIC_WIN_WAVE_COINS.json';
				break;
			default:
				console.error('no name of particle provided');

				return;
		}
		const particlesConfig: AnimatedMaskParticleArt[] = [];

		this._particleData = this.resources.getParticleData(resourcePath);
		const coinFrames: PIXI.Sprite[] = this.getCoinSpritesheetAnimation();

		particlesConfig.push({
			framerate: 0.06,
			loop: true,
			particleImages: coinFrames,
		});

		return particlesConfig;
	}

	protected getCoinSpritesheetAnimation(): PIXI.Sprite[] {
		const coinFrames: PIXI.Sprite[] = [];
		const baseString: string = 'Coin_';
		const endString: string = '.png';
		const device: string = this.device.desktop ? 'DESKTOP' : 'MOBILE';
		const frameKeys = this.resources.getSpriteSheet(this.resources.getPathForResource(`resources/particles/${device}/COIN.json`))
			._frameKeys;

		for (let i = 1; i <= frameKeys.length; i++) {
			coinFrames.push(
				new PIXI.Sprite(
					this.resources.getSpritesheetTexture(
						this.resources.getPathForResource(`resources/particles/${device}/COIN.json`),
						baseString + i.toString() + endString,
					),
				),
			);
		}

		coinFrames.splice(0, 1);

		return coinFrames;
	}

	protected startParticleEmitter(emitter: Emitter): void {
		this._currentParticleEmitter = emitter;
		this.updateManager.remove(this._currentParticleEmitter);

		this._currentParticleEmitter.emit = true;
		this.updateManager.add(this._currentParticleEmitter);

		this._currentParticleEmitter.start();
	}

	protected createAutoPlayButtonSprite(): PIXI.Sprite {
		return new PIXI.Sprite(this.resources.getSpritesheetTexture('resources/HUD.json', 'AUTOPLAY.png'));
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/particles/ParticleView.ts